<div class="page-layout blank fullwidth p-12" style="height: 1px; overflow-y: scroll; top: 1px;" >
  <div class="Item">
    <div style="display: flex;gap: 16px;width: 100%;">
      <i (click)="goBack()" class="material-icons12" >arrow_back</i>
      <h2 class="id">Customer ID # {{data?.customerId}}</h2>
      
    </div>
  <div class="spares-card">
    <div class="jobcard-new-tag" *ngIf="data?.gstNumber?.length>0">
      Business
    </div>
    <div class="jobcard-tag" *ngIf="!(data?.gstNumber?.length>0)">
      Individual
    </div>
    <div class="fullCust">
      <div class="logo-container1"  >
      <div class="logo">
        <img src="../../../../assets/images/order-details/ic_order.svg">
      </div>
      </div>
      <div class="detailsCus">
        <p style="color: black;">Customer ID # {{data?.customerId}}</p>
        <p *ngIf="data?.gstNumber?.length>0">{{data?.businessName}}</p>
        <p *ngIf="!(data?.gstNumber?.length>0)">{{data?.customerName}}</p>
        <p>{{data?.totalVehicles}} Vehicles</p>
      </div>
      <div class="outstand">
        <p>Outstanding Amt: {{data?.outstandingAmount}}</p>
        <p>Ph: {{data?.mobile}} </p>
        <p *ngIf="data?.lastJob">Last Job: {{data?.lastJob | date: 'dd MMM yyyy'}} </p>
      </div>
    </div>
    </div>

    <div class="container"  [ngClass]="{
      'container': !isMobile,
      'containerMobile': isMobile
    }">
      <!-- Sidebar -->
      <div class="mat-filter-list">
          <mat-card
            class="mat-filter-item"
            *ngFor="let item of registrationNumbers; let i = index"
            [class.active]="i === selectedIndex"
            (click)="selectFilter(item)"
          >
            <div class="mat-filter-content">
              <div class="mat-filter-text">
                <div class="spares-card1">
                  <div class="logo-containerSide"  >
                  <div class="logo">
                    <img [src]="'https://cube.getpitstop.com/assets/img/' + (vehicleData[item].make ? vehicleData[item].make.toLowerCase().replace(' ', '') : 'N/A') + '.png'" alt="Logo" />
                  </div>
                  </div>
                  <div class="details">
                    <p style="font-weight: bold;font-size: 13px;">{{vehicleData[item].model }}, {{vehicleData[item].fuelType}}</p>
                    <p>{{vehicleData[item].variant }}, [{{vehicleData[item].manufactureYear }}]</p>
                    <p>{{vehicleData[item].registrationNumber }}</p>
                    <p>{{vehicleData[item].vinNumber }}</p>
                  </div>
                </div>
                <!-- <div class="mat-filter-subtitle">{{ item.subtitle }}</div> -->
              </div>
            </div>
          </mat-card>
        </div>
        
        
      <div class="content"> 
          <div class="buttons" >
              <button class="request-button" 
                      [ngClass]="{'active': selectedTab === 'jobCard'}"
                      (click)="selectTab('jobCard')">JOB CARDS</button>
              <button class="request-button" 
                      [ngClass]="{'active': selectedTab === 'invoice'}"
                      (click)="selectTab('invoice')">INVOICES </button>
              <button class="request-button" 
                      [ngClass]="{'active': selectedTab === 'payment'}"
                      (click)="selectTab('payment')">PAYMENT RECORDS</button>
            </div>
            <div *ngIf=" selectedTab === 'jobCard'">
               <button #myButton class="create-jobcard-in-customer" (click)="loadorderdetails()">Create Job Card</button>
              <div class="header" *ngFor="let jobCard of selectedVehicleData">
                <div> 
                  <div class="jobcard-new-tag1" *ngIf="jobCard?.jobCardDetails.isExistingCustomer === true">
                    Repeat Customer
                  </div>
                  <div class="jobcard-tag1" *ngIf="jobCard?.jobCardDetails.isExistingCustomer === false || jobCard?.jobCardDetails.isExistingCustomer === 'null' || jobCard?.jobCardDetails.isExistingCustomer === null">
                    New Customer
                  </div>
                  <!-- -----------READY TAG----------- -->
                </div>
                <!-- --------------------------------------------------------------------------------------------------------------------------- -->
                <div class="header-row" >
        
                  <div class="request-info">
                    <div class="header-top-row">
                      <div class="order-icon" style="margin-top: 14px;">
                        <div class="car-img">
                          <img [src]="'https://cube.getpitstop.com/assets/img/' + (jobCard.jobCardDetails.make ? jobCard.jobCardDetails.make.toLowerCase().replace(' ', '') : 'N/A') + '.png'"  alt="Car Make Image" class="model-icon">
                        </div>
                      </div>
                      <div class="name-mbl-num">
                        <div class="book-id">Job Card ID # {{ jobCard.jobCardDetails.id }}</div>
                        <div class="name">{{ jobCard.jobCardDetails.model }}, {{ jobCard.jobCardDetails.fuelType }}</div>
                        <div class="mobile-number">{{ jobCard.jobCardDetails.variant }}</div>
                        <div class="mobile-number">{{ jobCard.jobCardDetails.registrationNumber }}</div>
                      </div>
                      <div class="newlyaddedcls">
                        <div class="right-container">
                          <div *ngFor="let status of filters.jobCardStatus">
                            <label class="rightcontainerlabel {{status.statusclass}}" *ngIf="(status.value==jobCard.jobCardDetails.jobCardStatus)">{{status.label}}</label>                    
                          </div>
                          <!-- <mat-icon (click)="openBottomSheet(jobCard)"> attach_file</mat-icon> -->
                          <!-- <div class="right-container-icon" (click)="shareOnWhatsApp()">
                            <i class="share-icon">share</i>
                          </div> -->
                        </div>
                      
                      <div *ngIf="jobCard.jobCardDetails.rating > 0; else getFeedback" class="food-rating">
                        <div class="ratingss">Your Service Rating</div>
                        <div class="rating">
                            <span class="star">&#9733;</span>
                            <span class="score">{{ jobCard.jobCardDetails.rating }}</span>
                            <div *ngIf="jobCard.jobCardDetails.feedback !== null" class="toolbar-separator"></div>
                            <!-- <span class="review">{{ jobCard.jobCardDetails.feedback }}</span> -->
                            <span class="review">
                                {{ jobCard.jobCardDetails.rating === 1 ? 'Terrible' : 
                                  jobCard.jobCardDetails.rating === 2 ? 'Bad' : 
                                  jobCard.jobCardDetails.rating === 3 ? 'Disappointing' : 
                                  jobCard.jobCardDetails.rating === 4 ? 'Pleasant' : 
                                  jobCard.jobCardDetails.rating === 5 ? 'Awesome' : 'Not Rated' }}
                            </span>
                        </div>
                    </div>
                    
                    <!-- Show "Get Feedback" button only when rating is 0 or less -->
                    <ng-template #getFeedback>
                      <button mat-button class="ghost-button" matTooltip="Get Feedback" 
                          *ngIf="(jobCard?.jobCardDetails.jobcardStatus === 4 || jobCard?.jobCardDetails.jobcardStatus === 5) && !jobCard?.jobCardDetails.rating" (click)="sendFeedback(jobCard.jobCardDetails.id,jobCard.jobCardDetails.jobcardStatus)">
                          Get Feedback
                      </button>
                  </ng-template>
                              
                    </div>
                      <!-- <div class="right-container"> -->
                        <!-- <div *ngFor="let status of filters.jobCardStatus">
                          <label class="{{status.statusclass}}" *ngIf="jobCard.jobcardStatus && status.value==jobCard.jobcardStatus">{{status.label}}</label>                    
                        </div> -->
                        <!-- <mat-icon (click)="openBottomSheet(jobCard)"> attach_file</mat-icon> -->
                        <!-- <div class="right-container-icon" (click)="shareOnWhatsApp()">
                          <i class="share-icon">share</i>
                        </div> -->
                      <!-- </div> -->
        
                    </div>
                  </div>
                </div>
          
                <div class="header-row2">
                  <div class="placed-on-date">{{ jobCard.jobCardDetails.name }}</div>
                  <a class="view-btn">
                    <span class="phone-number">{{ jobCard.jobCardDetails.phoneNumber }}</span>
                  </a>
                </div>
                <div class="header-row3">
                  <div class="placed-on-date"> Placed On {{ jobCard.jobCardDetails.createdAt | date:'dd MMM yyyy, h:mm a' }}</div>
                  <a class="view-btn" [routerLink]="['/my-job-cards-details', jobCard.jobCardDetails.id, jobCard.jobCardDetails.bookingId]">
                    <span class="job-card">View Details</span>
                    <i class="material-icons" style="color: #4caf50; float: left;">arrow_right</i> 
                  </a>
                </div>
              </div>
            </div>
            <div *ngIf=" selectedTab === 'invoice'">
              <div *ngFor="let list of selectedVehicleData">
                <div class="headerInvoice" *ngIf="!(list.invoice.length <= 0)">  
                  <div class="header-rowInvoice">
                    <!-- <div [ngClass]="isMobile ? 'order-iconMobile' : 'order-icon'">
                      <i class="material-icons">check_box</i>
                    </div> -->
                    <div class="order-info">
                      <div class="order-status">
                        <h1 *ngIf="list?.invoice.id" >
                          Invoice #{{ list?.invoice.id }}</h1>
                        <!-- <div 
                          class="delivery-status" 
                          *ngIf="!isMobile"
                          [ngClass]="{
                              'delivered-status': list.orderCurrentStatus === 'Delivered',
                              'confirmed-status': list.orderCurrentStatus === 'Confirmed',
                              'packed-status': list.orderCurrentStatus === 'Packed',
                              'on-the-way':list.orderCurrentStatus==='On The Way'}">
                            {{list.orderCurrentStatus}}
                        </div> -->
                        <div class="delivery-status" *ngFor="let status of filters1.jobCardStatus" >
                          <label class="{{status.statusclass}}" *ngIf="list.invoice.status && status.value==list.invoice.status" >{{status.label}}</label>  
            
                        </div>
                      </div>
                      <div class="request-ids" style="margin-top: -3px;">
                      <div class="request-id jobcardId"  *ngIf="list?.jobCardDetails.id">Job Card # {{list.jobCardDetails.id}}</div>
          
                      <!-- <div class="request-id" *ngIf="list.quoteId">Quote # {{list.quoteId}}</div> -->
                      <!-- <div class="order-amount">Total Amount - ₹{{list.grandTotal}} </div> -->
                      <div class="order-amount" >
                        Total Amount - ₹{{ list.invoice.totalAmount|number:'1.2-2' }}
                        </div>
                      <div style="margin-top: 11px;" *ngIf="list?.jobCardDetails.make">
                      <div class="logo-containerInvoice"  >
                        <div class="logoInvoice">
                        <img 
                            [src]="'https://cube.getpitstop.com/assets/img/' + list.jobCardDetails.make.toLowerCase().replace(' ', '') + '.png'" 
                            alt="Make Image"
                          >
                        </div>
                      
                      </div>
                    
                      <div class="model-sec" style="width:80%;" *ngIf="list?.jobCardDetails.model">
                        <p style="font-weight:bold">{{list.jobCardDetails.model}}, {{list.jobCardDetails.fuelType}}</p>
                        <p>{{list.jobCardDetails.variant}} [{{list.jobCardDetails.year}}]</p>
                        <p>{{list?.jobCardDetails.registrationNumber}}</p>
                        <p *ngIf="list?.jobCardDetails.vinNumber">{{list.jobCardDetails.vinNumber}}</p>
                    </div>
                  </div>
                    </div>
                  </div>
          
                  </div>
                  <div class="header-row1">
                    <div class="order-item"><span *ngFor="let items of list.invoice.invoiceItems; index as i"><span *ngIf="i!=0">,</span> {{list.invoice.itemName}}</span></div>
                  </div>
                  <div class="header-row21">
                    <div class="order-date">
                      <span>Placed on: {{list.invoice.updatedAt | date: 'dd MMM yyyy'}}, {{list.invoice.updatedAt | date: 'hh:mm a'}}</span>
                      <button (click)="navigateToDetails(list.invoice.id,list.jobCardDetails.id,list.invoice.quoteId)" class="Viewbtn">
                        <span class="view">View Details</span>
                        <i class="material-icons">arrow_right</i> 
                      </button>
                    </div>
                  </div>
                </div>
                </div>
            </div> 
            <div *ngIf="selectedTab === 'payment'">
              <div  *ngFor="let items of selectedVehicleData">
                <div *ngFor="let item of items.payments">
                <div class="main-content" *ngIf="items.payments.length>0">
                <div class="second-main">
                    <div class="order-header">
                        <div class="order-status" style="width: 76%;">Payment ID # {{ item.id || 'N/A' }}</div>
                        <div class="status-badge">
                            {{ item.paymentStatus == 1 ? 'Paid' : item.paymentStatus == 2 ? 'Partially Paid' : 'Pending' }}
                        </div>                
                        
                    </div>
                    <div class="order-details">
                        <p class="order-number">Invoice No # {{ item.invoiceId || 'N/A' }}</p>
                        <p class="total-amount">Job Card # {{ items.jobCardDetails.id || 'N/A' }}</p>
                        <div class="vehicle-details">
                            <div class="logo-container">
                                <img [src]="'https://cube.getpitstop.com/assets/img/' + (items.jobCardDetails.make ? items.jobCardDetails.make.toLowerCase().replace(' ', '') : 'N/A') + '.png'" 
                                    alt="Make Image" class="car-icon" />
                            </div>
                            <div class="vhclnameandinfo">
                                <div class="vehicle-name"><strong>{{ items.jobCardDetails.model || 'N/A' }}, {{ items.jobCardDetails.fuelType || 'N/A' }}</strong></div>
                                <div class="vehicle-info">{{ items.jobCardDetails.variant || 'N/A' }} [{{ items.jobCardDetails.year || 'N/A' }}]</div>
                                <div class="vehicle-regNo">{{ items.jobCardDetails.registrationNumber || 'N/A' }}</div>
                                <div class="vehicle-regNo">{{ items.jobCardDetails.vinNumber || 'N/A' }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="amountpaid-amountdue">
                    <div class="item-list" >Total Amount Paid: ₹{{ item.amountPaid || 'N/A' }}</div>
                    <div class="amount-due" *ngIf="item.paymentStatus == 2">
                        Total Amount Due: ₹{{ (item.amountPending) | number:'1.2-2' || 'N/A' }}
                      </div>
                    </div>
            
                <div class="dateandview">
                    <div class="placed-date">Paid on: {{ item.paymentDate || 'N/A' }}</div>
                    <button class="Viewbtn" (click)="openRecordPaymentSidebar(item.id,items.jobCardDetails.id)">
                        <span class="view" >View Details</span>
                        <i class="material-icons">arrow_right</i> 
                    </button>           
                </div>
                
              </div>
            </div>
              </div>
            </div> 
      </div>

  </div>
  </div>
</div>
<div #dynamicContainer></div>